import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";
import {setErrors, setModel} from "features/model/slice/create-test/add-test/responseAddTest";

interface TestFormData {
    title: string;
    available: string;
    selectedGroupIds: number[];
    selectedStudentIds: number[];
}

export const fetchAddTest = createAsyncThunk(
    'test/addTest',
    async (requestData: TestFormData, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error('No token found in localStorage.');
            }
            const { token } = JSON.parse(authToken);


            const response = await axios.post(
                '/api/tests',
                requestData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data.success) {
                thunkAPI.dispatch(setModel(response.data.model));

            } else {
                thunkAPI.dispatch(setErrors(response.data));
                throw new Error('Error saving test.');
            }

            return response.data;
        } catch (error) {
            console.error('Произошла ошибка:', error);
            throw error;
        }
    }
);